module.exports = __webpack_public_path__ + "img/T1D_xh11.39adc7b6.png";